export const PAYMENT_LINKS_WRITE = 'payment-links-write';
export const INVOICES_WRITE = 'invoices-write';
export const QUOTE_CREATE = 'quote-create';
export const SUBSCRIPTIONS_WRITE = 'subscriptions-write';